import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Awardshealthcare() {
  return (
    <section className="awards_healthcare p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="m-auto text-center"
          >
            <h2>Our Recognition in Healthcare</h2>
          </Col>
        </Row>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="health_awards">
              <div className="health_awards_item">
                <div className="health_awards_img">
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/award_1.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={199}
                    height={131}
                  />
                </div>
              </div>
              <div className="health_awards_item">
                <div className="health_awards_img">
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/award_2.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={198}
                    height={131}
                  />
                </div>
              </div>
              <div className="health_awards_item">
                <div className="health_awards_img">
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/awards_3.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={198}
                    height={131}
                  />
                </div>
              </div>
              <div className="health_awards_item">
                <div className="health_awards_img">
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/award_4.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={198}
                    height={131}
                  />
                </div>
              </div>
              <div className="health_awards_item">
                <div className="health_awards_img">
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/award_5.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={198}
                    height={131}
                  />
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Awardshealthcare;
